<template>
  <app-base-main
      parentTable
      :no-padding="!padding"
      :table-shadow="tableShow">
    <template #filter-group>
      <market-analysis-filter
          ref="marketFilter"
          @manual-query="manualQuery"
          :query-loading.sync="queryBtnLoading"
          :show-currency="statisticsField === 'orderProductSales'"
          :paginations="pagination"
          @reset="reset"
          @set-pagination="setPagination"
          @search="search">
        <template #default>
          <gj-radio-group
              v-model="dateQueryType"
              :options="option.rangeRadio"
          ></gj-radio-group>
        </template>
      </market-analysis-filter>
    </template>
    <template #operate-group>
      <gj-radio-group
          v-model="statisticsField"
          :options="option.analysisRadio"
          @input="statisticsFieldChange()"
      ></gj-radio-group>
    </template>
    <template #tool-group>
       <!-- :download="$permission('storeStatistics:export')" -->
      <gj-tool-group
          :download="$permission('listingAnalyze:export')"
          download-url="/operation/storeAnalyze/statistics/export" :download-params="downloadParams"
          help
      ></gj-tool-group>
    </template>
    <template #table>
      <analysis-table
          :data="data"
          adaptParent
          :columns="columns"
          :loading="loading"
          :query-params="globalParams"
          :show-summary="isMeaningful(summaryObject)"
          :summary-object="summaryObject"
          :pagination="pagination"
          @sort-change="$gjSortChange"
          @page-change="pageChange"
      ></analysis-table>
    </template>
  </app-base-main>
</template>

<script>
  import {analysisInitKey, initCol, marketField, rangeRadio, saleRadio} from "../analysis-fields";
  import MarketAnalysisFilter from "./market-analysis-filter";
  import AnalysisTable from "../analysis-table";
  import {queryMixin, noRepeatQueryMixin} from "@/minxins";
  import {getMarketStatisticsAnalysis} from "@/api/statistics";
  import {isMeaningful} from "@/utils/common";
  import {analysisMixin} from "modules/statistics/common/analysis/mixins";
  import {isMeaningfulMixin} from "../../../../../../minxins";

  export default {
    name: "app-market-analysis-statistics",
    components: {AnalysisTable, MarketAnalysisFilter},
    mixins: [queryMixin, analysisMixin, isMeaningfulMixin, noRepeatQueryMixin],
    data() {
      return {
        statisticsField: 'unitsOrdered',
        dateQueryType: 'day',
        data: [],
        columns: [],
        option: {
          analysisRadio: saleRadio,
          rangeRadio: rangeRadio,
        },
        summaryObject: null,
        downloadParams: null
      }
    },
    created() {
      const tabs = this.$cacheTab.getCache() || {}
      this.sort.prop = 'subtotal';
      // const tabs = localStorage.getItem('market-statistics-children-tabs')
      this.statisticsField = tabs.val || this.statisticsField

    },
    methods: {
      pageChange() {
        this.$refs.marketFilter.setCacheDatas()
        this.$gjNoticeQuery()
      },
      setPagination(pages) {
        this.pagination.pageSize = pages.pageSize || 20
      },
      manualQuery() {
        this.$gjQuery()
      },
      $gjQuery() {
        this.resetSort();
        this.loading = true;
        this.queryBtnLoading = true;
        let params= {
          model: {
            ...this.globalParams,
            dateQueryType: this.dateQueryType,
            statisticsField: this.statisticsField
          },
          ...this.queryPagination,
          ...this.querySort
        }
        this.downloadParams = params;
        getMarketStatisticsAnalysis(params)
          .then(res => {
            this.initDataId(res.data);
            this.buildCol(res.other);
            this.data = res.data.records;
            this.summaryObject = res.data.statisticRecord;
            this.pagination = this.getPagination(res.data);
          })
          .complete(() => {
            this.loading = false
            this.queryBtnLoading = false
          });
      },
      statisticsFieldChange() {
        this.$cacheTab.setCache({params: {val: this.statisticsField}})
        // localStorage.setItem('market-statistics-children-tabs', this.statisticsField)
        this.$refs['marketFilter'].$gjNoticeQuery();
      },
      search(params) {
        this.params = this.globalParams = params;
        this.pagination.currentPage = 1;
        this.$gjNoticeQuery();
      },
      reset(params) {
        this.params = this.globalParams = params;
        this.pagination.currentPage = 1;
        this.$cacheTab.removeCache()
        this.statisticsField = 'unitsOrdered'
        // localStorage.removeItem('CACHE_MARKET_ANALYSIS_FILER_marketAnalysis')
        this.$gjReset()
      },

      initDataId(data) {
        if (isMeaningful(data.records) && data.records.length > 0) {
          analysisInitKey(data.records, 'detailMap');
          analysisInitKey(data.records, 'ordersDetailMap');
        }
      },
      buildCol(other) {
        this.columns = [
          ...marketField,
          {id: 'marketAnalysis', header: '店铺分析', field: 'slot:marketAnalysis', minWidth: '80px', fixed: 'left'},
          {id: 'fulfillableQuantity', field: 'slot:fulfillableQuantity', header: 'FBA可售', align: 'right', help: '当前FBA仓库可售量', summary: true, minWidth: '120px', default: false, sortable: true},
          {id: 'saleableTurnover', field: 'slot:saleableTurnover', header: 'FBA可售周转', align: 'right', help: 'FBA可售周转=FBA可售/7天日均销量', summary: true, minWidth: '120px', default: false},
          {id: 'fulfillableQuantityFBM', field: 'slot:fulfillableQuantityFBM', header: 'FBM可售', align: 'right', help: '当前FBM仓库可售量', summary: true, minWidth: '120px', default: false, sortable: true},
          {id: 'saleableTurnoverFBM', field: 'slot:saleableTurnoverFBM', header: 'FBM可售周转', align: 'right', help: 'FBM可售周转=FBM可售/7天日均销量', summary: true, minWidth: '120px', default: false},
          {id: 'fulfillableQuantityAmount', field: 'fulfillableQuantityAmount', header: '可售货值',summary: true,prefix: 'currencySymbol', align: 'right', sortable: false, minWidth: '120px', default: true},
          ...initCol(other, this.statisticsField, this.dateQueryType)
        ];
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .vxe-cell--sort{
    margin-right: -2px;
  }
</style>
